export const navLinks = [
  { to: '/', label: '首页' },
  { to: '/cases', label: '吃瓜事件库' },
  { to: '/charts', label: '人物关系图' },
  { to: '/responses', label: '当事人回应' },
  { to: '/chains', label: '矛盾链条' },
  { to: '/about', label: '关于我们' },
];

export const categories = [
  { id: 'gan-qing', name: '情感关系', desc: '绯闻、恋情与私人关系的蛛丝马迹', icon: 'ri-heart-3-line' },
  { id: 'he-yue', name: '合约风波', desc: '签约、解约与版税之间的拉锯', icon: 'ri-file-list-3-line' },
  { id: 'he-zuo', name: '合作纠纷', desc: '剧组、番位与创作分工的角力', icon: 'ri-team-line' },
  { id: 'dai-yan', name: '商务代言', desc: '代言替换与商务排期的来龙去脉', icon: 'ri-award-line' },
  { id: 'yan-lun', name: '言论争议', desc: '剪辑、语境与被误读的一句话', icon: 'ri-chat-quote-line' },
];

export const stats = [
  { label: '已梳理事件', value: '320+', suffix: '个' },
  { label: '人物关系条目', value: '1,480', suffix: '条' },
  { label: '当事人回应收录', value: '760', suffix: '条' },
  { label: '矛盾链条节点', value: '2,100', suffix: '个' },
];

export const hotTopics = [
  { title: '苏晚宁 × 陆则言 同框细节再更新', heat: '96', caseId: 'su-lu-lian-ai' },
  { title: '星河唱片再发律师函，解约风波升级', heat: '89', caseId: 'xing-he-jie-yue' },
  { title: '《长夜微光》路演回应番位讨论', heat: '82', caseId: 'chang-ye-san-ren' },
  { title: '顾昭回应代言替换：属正常排期调整', heat: '74', caseId: 'gu-zhao-dai-yan' },
  { title: '温知夏放出完整直播回放', heat: '68', caseId: 'wen-zhi-xia-jian-ji' },
  { title: '《长夜微光》编剧首次谈改编取舍', heat: '65', caseId: 'chang-ye-san-ren' },
];

export const testimonials = [
  { name: '瓜田里的猹', tag: '老读者', content: '别的地方只给结论，这里把关系图画出来、时间线排出来，前因后果一眼就懂，省了无数翻旧帖的时间。' },
  { name: '吃瓜研究院', tag: '内容创作者', content: '矛盾链条这个板块是真的有用，把零散信息按时间排好之后，谁是起因、谁在回应就清楚了。' },
  { name: '晚风不吃瓜', tag: '普通用户', content: '语气算是克制的，至少标注了哪些是回应、哪些还只是传闻，不会跟着标题下结论。' },
  { name: '理性围观群众', tag: '老读者', content: '人物档案挺全的，看新瓜之前先翻一下关系网，基本就能对上号了。' },
];

export const generalFaq = [
  {
    q: '911吃瓜的内容主要整理哪些信息？',
    a: '我们把每个话题拆成三部分：人物关系图用来梳理谁和谁有交集，矛盾链条按时间排列事件节点，当事人回应则收录公开表态。三者配合，帮助你快速看懂一件事的来龙去脉。',
  },
  {
    q: '站内的关系图是怎么来的？',
    a: '关系图由编辑根据公开报道、官方声明与可核实的时间节点整理而成，每一条连线都会标注关系类型，尽量区分"已确认"与"仍在讨论中"的信息。',
  },
  {
    q: '为什么有些当事人显示"未回应"？',
    a: '"未回应"表示截至信息更新时，尚未找到该当事人或团队的公开表态。我们不会替任何人补充观点，也欢迎读者提供可靠来源帮助我们更新。',
  },
  {
    q: '发现内容有误怎么办？',
    a: '可以通过页面底部的联系方式告诉我们。核实后我们会尽快更正，并在事件详情中注明更新时间，保持信息的可追溯。',
  },
];

export const contactInfo = {
  email: 'hello@911chigua.example.com',
  press: 'press@911chigua.example.com',
  hours: '每日 09:00 - 23:00 更新',
};

export const siteMeta = {
  name: '911吃瓜',
  slogan: '吃透每一个瓜的来龙去脉',
  intro:
    '911吃瓜是一个专注娱乐话题梳理的内容站，核心是把零散的信息整理成人物关系图、矛盾链条时间线与当事人回应合集，让每一次围观都有据可查。',
  domain: 'https://czpjhw.cn',
};